import * as React from "react";
import { useState } from "react";
import DatePicker from "react-datepicker";
import { addDays } from "date-fns";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import "react-datepicker/dist/react-datepicker.css";
import Box from "@mui/material/Box";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import InputAdornment from "@mui/material/InputAdornment";
import Input from "@mui/material/Input";
import moment from "moment";
// import {
//   Button,
//   Divider,
//   InputLabel,
//   TextField,
//   Typography,
// } from "@mui/material";

export default function DeliveryDetailsCalender({ setsubDetails, subDetails }) {
  // const [startDate, setStartDate] = useState(new Date());
  // const [endDate, setEndDate] = useState(null);
  // const onChange = (dates) => {
  //   const [start, end] = dates;
  //   setStartDate(start);
  //   setEndDate(end);
  // };
  // return (
  //   <DatePicker
  //     selected={startDate}
  //     onChange={onChange}
  //     startDate={startDate}
  //     endDate={endDate}
  //     excludeDates={[addDays(new Date(), 1), addDays(new Date(), 5)]}
  //     selectsRange
  //     selectsDisabledDaysInRange
  //     inline
  //   />
  // );

  const [startDate, setStartDate] = useState(
    new Date(moment().add(1, "days").format("YYYY-MM-DD"))
  );
  const [endDate, setEndDate] = useState(null);
  const [currentDate, setCDate] = useState(
    moment().add(1, "days").format("YYYY-MM-DD")
  );
  const onChange = (dates) => {
    const [start, end] = dates;

    let c = moment().add(1, "days").format("YYYY-MM-DD");
    let s = moment(start).format("YYYY-MM-DD");
    let e = moment(end).format("YYYY-MM-DD");
    let d = moment(e).diff(moment(s), "days");

    if (e == "Invalid date") {
      e = s;
    }

    if (new Date(s) > new Date(c)) {
      setStartDate(start);
    }

    if (new Date(e) > new Date(c)) {
      setEndDate(end);
    }
    setsubDetails({
      ...subDetails,
      startDate: s,
      endDate: e,
      noOfDays: d ? d + 1 : 1,
    });
    // setStartDate(start);
  };
  return (
    <>
      <Box
        pt="8px"
        pb="24px"
        sx={{
          display: "flex",
          flexDirection: { lg: "row", md: "row", sm: "column", xs: "column" },
          width: "100%",
          // border:"1px solid red"
        }}
      >
        <Box sx={{ width: "100%" }}>
          <Input
            fullWidth
            disableUnderline="true"
            placeholder="Select date"
            endAdornment={
              <InputAdornment position="start">
                <CalendarMonthIcon sx={{ color: "#9EA3AE" }} />
              </InputAdornment>
            }
            sx={{
              borderColor: "#E1E1E6",
              border: "1px solid",
              // minWidth: "337px",

              // width: {
              //   xl: "337px",
              //   // lg: "300px",
              //   lg: "100%",
              //   md: "205px",
              //   sm: "45%",
              //   xs: "45%",
              // },
              height: {
                lg: "56px",
                md: "56px",
                // sm: "45%",
                xs: "40px",
              },
              borderRadius: "4px",
              padding: "15px, 24px, 15px, 24px",
              gap: { lg: "16px", md: "16px", sm: "0px", xs: "0px" },
              backgroundColor: "#F6F6F6",
              color: "#9EA3AE",
              paddingLeft: "27.12px",
            }}
          ></Input>
        </Box>

        <Box
          // pl="24px"
          sx={{
            width: "100%",
            px: { lg: 2, md: 2, sm: 0, xs: 0 },
            my: { lg: 0, md: 0, sm: 1, xs: 2 },
            // border:"1px solid red"
          }}
        >
          <Input
            fullWidth
            disableUnderline="true"
            placeholder="Select date"
            endAdornment={
              <InputAdornment position="start">
                <CalendarMonthIcon sx={{ color: "#9EA3AE" }} />
              </InputAdornment>
            }
            sx={{
              borderColor: "#E1E1E6",
              border: "1px solid",
              // minWidth: "337px",
              // width: {
              //   xl: "337px",
              //   // lg: "300px",
              //   lg: "100%",
              //   md: "205px",
              //   sm: "45%",
              //   xs: "45%",
              // },
              height: {
                lg: "56px",
                md: "56px",
                // sm: "45%",
                xs: "40px",
              },
              borderRadius: "4px",
              padding: "15px, 24px, 15px, 24px",
              gap: { lg: "16px", md: "16px", sm: "0px", xs: "0px" },
              backgroundColor: "#F6F6F6",
              color: "#9EA3AE",
              paddingLeft: "27.12px",
            }}
          ></Input>
        </Box>
      </Box>

      <Box fullWidth sx={{ width: "100%" }}>
        <DatePicker
          renderCustomHeader={({
            monthDate,
            customHeaderCount,
            decreaseMonth,
            increaseMonth,
          }) => (
            <div>
              <button
                aria-label="Previous Month"
                className={
                  "react-datepicker__navigation react-datepicker__navigation--previous"
                }
                style={
                  customHeaderCount === 1 ? { visibility: "hidden" } : null
                }
                onClick={decreaseMonth}
              >
                <span
                  className={
                    "react-datepicker__navigation-icon react-datepicker__navigation-icon--previous"
                  }
                >
                  {"<"}
                </span>
              </button>
              <span className="react-datepicker__current-month">
                {monthDate.toLocaleString("en-US", {
                  month: "long",
                  year: "numeric",
                })}
              </span>
              <button
                aria-label="Next Month"
                className={
                  "react-datepicker__navigation react-datepicker__navigation--next"
                }
                style={
                  customHeaderCount === 0 ? { visibility: "hidden" } : null
                }
                onClick={increaseMonth}
              >
                <span
                  className={
                    "react-datepicker__navigation-icon react-datepicker__navigation-icon--next"
                  }
                >
                  {">"}
                </span>
              </button>
            </div>
          )}
          selected={startDate}
          // onChange={(date) => setStartDate(date)}
          monthsShown={2}
          inline
          // selected={startDate}
          onChange={onChange}
          startDate={startDate}
          endDate={endDate}
          // excludeDates={[addDays(new Date(), 1), addDays(new Date(), 5)]}
          selectsRange
          selectsDisabledDaysInRange
          minDate={new Date(currentDate)}
        />
      </Box>
    </>
  );
}
